module.exports = __webpack_public_path__ + "img/icon-tip-empty.abdf29a7.png";